var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifetimingMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7720_6793)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70135 0.737374C7.88904 0.643532 8.10995 0.643532 8.29764 0.737374L14.9643 4.07071C15.1902 4.18364 15.3328 4.41448 15.3328 4.66699C15.3328 4.91951 15.1902 5.15035 14.9643 5.26328L8.29764 8.59661C8.10995 8.69045 7.88904 8.69045 7.70135 8.59661L1.03469 5.26328C0.80883 5.15035 0.666162 4.91951 0.666162 4.66699C0.666162 4.41448 0.80883 4.18364 1.03469 4.07071L7.70135 0.737374ZM2.82354 4.66699L7.99949 7.25497L13.1754 4.66699L7.99949 2.07901L2.82354 4.66699Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.736544 11.0355C0.901203 10.7062 1.30165 10.5727 1.63097 10.7374L7.99949 13.9216L14.368 10.7374C14.6973 10.5727 15.0978 10.7062 15.2624 11.0355C15.4271 11.3648 15.2936 11.7653 14.9643 11.9299L8.29764 15.2633C8.10995 15.3571 7.88904 15.3571 7.70135 15.2633L1.03469 11.9299C0.705367 11.7653 0.571884 11.3648 0.736544 11.0355Z",
    fill: "#7E716D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.736544 7.70218C0.901203 7.37286 1.30165 7.23938 1.63097 7.40404L7.99949 10.5883L14.368 7.40404C14.6973 7.23938 15.0978 7.37286 15.2624 7.70218C15.4271 8.0315 15.2936 8.43195 14.9643 8.59661L8.29764 11.9299C8.10995 12.0238 7.88904 12.0238 7.70135 11.9299L1.03469 8.59661C0.705367 8.43195 0.571884 8.0315 0.736544 7.70218Z",
    fill: "#7E716D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetimingMenuIcon);
export default __webpack_public_path__ + "static/media/lifetiming-menu-icon.4f6dfee600ebbd2b3f5408e12e8e7892.svg";
export { ForwardRef as ReactComponent };